import * as types from '@/store/types.js'
import Navigation from '@/model/Navigation'
import {removeResource, activeResource} from '@/store/helpers'

const state = {
  navigations: {
    pagination: {},
    data: {}
  },
  activeNavigation: {},
  isLoading: false
}

// GETTERS
const getters = {
  [types.ALL_NAVIGATIONS]: state => state.navigations,
  [types.ACTIVE_NAVIGATION]: state => state.activeNavigation,
  [types.IS_LOADING_NAVIGATIONS]: state => state.isLoading
}

// ACTIONS
const actions = {
  [types.GET_ALL_NAVIGATIONS]: ({ commit }, value) => {
    commit(types.GET_ALL_NAVIGATIONS, value)
  },
  [types.ADD_NAVIGATION]: ({ commit }, value) => {
    commit(types.ADD_NAVIGATION, value)
  },
  [types.REMOVE_NAVIGATION]: ({ commit }, value) => {
    commit(types.REMOVE_NAVIGATION, value)
  },
  [types.ACTIVE_NAVIGATION]: ({ commit }) => {
    commit(types.ACTIVE_NAVIGATION)
  },
  [types.IS_LOADING_NAVIGATIONS]: ({ commit }, value) => {
    commit(types.IS_LOADING_NAVIGATIONS, value)
  }
}

// MUTATIONS
const mutations = {
  [types.GET_ALL_NAVIGATIONS] (state, value) {
    state.navigations = value
  },
  [types.ADD_NAVIGATION]: (state, value) => {
    state.navigations.data.unshift(value)
  },
  [types.REMOVE_NAVIGATION]: (state, value) => {
    removeResource(Navigation, value, state.navigations, 'navigations.index')
  },
  [types.ACTIVE_NAVIGATION]: (state, value) => {
    state.activeNavigation = activeResource(state.navigations.data)
  },
  [types.IS_LOADING_NAVIGATIONS]: (state, value) => {
    state.isLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Navigation.js